/**
 * Google Ads conversion tracking helper.
 * Fires a `conversion` event only after the payment has been confirmed
 * server-side, using sessionStorage to guard against double-firing on
 * page refresh.
 */
const ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID || "";
const CONVERSION_LABEL = process.env.REACT_APP_GOOGLE_ADS_CONVERSION_LABEL || "";

export const fireGoogleAdsConversion = ({ transactionId, value, currency = "EUR" }) => {
  if (typeof window === "undefined") return false;
  if (!window.gtag) {
    console.warn("[ads] gtag not loaded — conversion not fired");
    return false;
  }
  if (!ADS_ID || !CONVERSION_LABEL) {
    console.info("[ads] conversion label not set — skipping fire");
    return false;
  }
  const guardKey = `ads_conv_${transactionId}`;
  if (sessionStorage.getItem(guardKey)) {
    return false;
  }
  window.gtag("event", "conversion", {
    send_to: `${ADS_ID}/${CONVERSION_LABEL}`,
    value: Number(value) || 0,
    currency,
    transaction_id: String(transactionId),
  });
  sessionStorage.setItem(guardKey, "1");
  console.info(
    `[ads] fired conversion: value=${value} ${currency} txn=${transactionId}`
  );
  return true;
};
